import angular from 'angular';
import moment from 'moment';

(() => {
  class Promos {
    constructor($http, Utils, API_URL, Endpoints, localStorageService) {
      'ngInject';

      Object.assign(this, {
        $http,
        Utils,
        API_URL,
        Endpoints,
        localStorageService,
        SINGLE_USE: 'single_use_code',
        MULTI_USE: 'multi_use_code',
        EMAIL_DOMAIN: 'email_domain',

        CUSTOMER_TYPES: {
          ALL: 'ALL',
          RETURNING: 'RETURNING',
          NEW: 'NEW',
        },

        DOLLAR: 'dollar',
        PERCENT: 'percent',
      });
    }
    /**
     * Retrieves list of promotions
     * @param  {Object} pagination pagination query
     * @return {Promise} http promise
     */

    all(pagination = {}) {
      const query = Object.assign({}, pagination);
      query.status = query.status && query.status.map(s => s.status).join('|');
      ['total', 'current'].forEach(key => delete query[key]);
      const queryString = this.Utils.serializeQuery(query);
      return this.$http.get(this.Endpoints.promos.base + `${queryString}`, {
        loadingText: 'Loading Promos',
      });
    }
    /**
     * Retrieves a promotion by id
     * @param  {Number} promoId promotion id
     * @return {Promise} http promise
     */

    fetch(promoId) {
      return this.$http.get(`${this.API_URL}/admin/promos/${promoId}`);
    }
    /**
     * Creates a new promotion
     * @param  {Object} promo new promotion object
     * @return {Promise} http promise
     */

    create(promo) {
      return this.$http.post(`${this.API_URL}/admin/promos`, promo);
    }
    /**
     * Updates an ongoing promotion
     * @param  {Number} promoId promotion id
     * @param  {Object} changes key-value changes
     * @return {Promise} http promise
     */

    update(promoId, changes) {
      return this.$http.put(`${this.API_URL}/admin/promos/${promoId}`, changes);
    }
    /**
     * Deletes an ongoing promotion
     * @param  {Number} promoId promotion id
     * @return {Promise} http promise
     */

    delete(promoId) {
      return this.$http.delete(`${this.API_URL}/admin/promos/${promoId}`);
    }
    /**
     * Export Single Use Prom'otion codes to a CSV file
     * @param  {Number} promoId promotion id
     * @param  {Number} promoName name of Promotion to be used in filename
     * @return {Promise} http promise
     */

    exportCodesToCSV(promoId, promoName) {
      this.$http
        .get(`${this.API_URL}/admin/promos/${promoId}/codes`, {
          headers: {
            Accept: 'text/csv',
          },
        })
        .then(({ data }) => {
          const csvRows = data.split('\n').splice(1); // 1 is a magic number to pull out code from CSV row

          const rowsWithCodeOnly = csvRows.map(row => [row.split(',')[1]]);
          const newData = ['Promotion Codes'].concat(rowsWithCodeOnly).join('\n');
          const filename = `${promoName.replace(' ', '')}-${moment().format('M.D.YY')}.csv`;
          const link = document.createElement('a');
          link.setAttribute('download', filename);
          link.setAttribute('href', encodeURI(`data:text/csv;charset=utf-8,${newData}`));
          link.click();
        });
    }
    /**
     * Generates single use codes only when creating a single use campaign
     * @param  {Number} promoId promotion id
     * @param  {Number} count how many codes to generate
     * @return {Promise} http promise
     */

    generateSingleUseCodes(promoId, count) {
      return this.$http.put(`${this.API_URL}/admin/promos/${promoId}/codes`, {
        count,
      });
    }
    /**
     * Retrieve codes for single use code campaign
     * @param  {Number} promoId promotion id
     * @param  {Object} pagination pagination query
     * @return {Promise} http promise
     */

    getSingleUseCodes(promoId, pagination) {
      const queryString = this.Utils.serializeQuery(pagination);
      return this.$http.get(`${this.API_URL}/admin/promos/${promoId}/codes${queryString}`);
    }

    getPromoCodeStyle(serviceCode) {
      const code = `promo-${serviceCode}`;
      const pimsParameter = this.localStorageService.get('pimsParameters');
      const promoStyles = pimsParameter?.promos?.styles;
      const promoCodeStyle = promoStyles && promoStyles[code];
      return promoCodeStyle || '';
    }
  }

  Promos.$inject = ['$http', 'Utils', 'API_URL', 'Endpoints', 'localStorageService'];
  angular.module('pims').service('Promos', Promos);
})();
